import React from 'react';
import PropTypes from 'prop-types';
import { CardTitle, Typography, Link } from '@one-thd/sui-atomic-components';
import { ListView } from '@one-thd/sui-icons';
import { showAboveSmBreakpoint } from '../../constants/responsiveClassNames';
import LearnMore from './LearnMore';

const ListsHeader = ({
  listCount, showLearnMoreLink, learnMoreText, hideActions, showOnlyCreate
}) => {
  const action = showLearnMoreLink ? (
    <div>
      <Link href="/c/create-a-list">{learnMoreText}</Link>
    </div>
  ) : (
    <div className="sui-flex sui-pb-4">
      <LearnMore variant="link" />
      {!showOnlyCreate && (
        <div className={showAboveSmBreakpoint}>
          {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
          <span className="sui-border-primary sui-mx-4 sui-border-r-[1px] sui-border-solid" />
          <Link href="/list/view/summary">View All Lists</Link>
        </div>
      )}
    </div>
  );

  return (
    <CardTitle
      header={(
        <div className="sui-flex sui-gap-3 sui-items-center">
          <ListView />
          <div className="sui-flex sui-gap-2 sui-items-center">
            <Typography variant="h4" weight="display">
              Lists
            </Typography>
            {listCount > 0 && (
              <Typography variant="body-base">
                ({listCount})
              </Typography>
            )}
          </div>
        </div>
      )}
      data-test-id="lists-header"
      actionPosition="end"
      action={hideActions ? null : action}
    />
  );
};
ListsHeader.propTypes = {
  listCount: PropTypes.number,
  showLearnMoreLink: PropTypes.bool,
  learnMoreText: PropTypes.string,
  hideActions: PropTypes.bool,
  showOnlyCreate: PropTypes.bool
};

ListsHeader.defaultProps = {
  listCount: 0,
  showLearnMoreLink: false,
  learnMoreText: 'Learn More',
  hideActions: false,
  showOnlyCreate: false
};

export default ListsHeader;
